import script from "./pageCommom.vue?vue&type=script&setup=true&lang=js"
export * from "./pageCommom.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__